export const money = (v, opts = {}) => {
    if (v === null || v === undefined || Number.isNaN(Number(v))) return "$0.00";
    const n = Number(v);
    return n.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: opts.decimals ?? 2,
        maximumFractionDigits: opts.decimals ?? 2,
    });
};

export const moneyShort = (v) => {
    const n = Number(v || 0);
    if (Math.abs(n) >= 1_000_000) return `$${(n / 1_000_000).toFixed(1)}M`;
    if (Math.abs(n) >= 1_000) return `$${(n / 1_000).toFixed(1)}k`;
    return money(n, { decimals: 0 });
};

export const formatDate = (iso) => {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
    } catch {
        return iso;
    }
};

export const formatDateTime = (iso) => {
    if (!iso) return "—";
    try {
        const d = new Date(iso);
        return d.toLocaleString("en-US", { year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
    } catch {
        return iso;
    }
};

export const STATUS_LABEL = {
    draft: "Draft",
    sent: "Sent",
    accepted: "Accepted",
    declined: "Declined",
    expired: "Expired",
};

export const STATUS_STYLE = {
    draft: "bg-slate-100 text-slate-700 border-slate-200",
    sent: "bg-[rgba(67,161,215,0.10)] text-[#1E6FA8] border-[rgba(67,161,215,0.25)]",
    accepted: "bg-[rgba(22,122,74,0.10)] text-[#167A4A] border-[rgba(22,122,74,0.25)]",
    declined: "bg-[rgba(180,35,24,0.08)] text-[#B42318] border-[rgba(180,35,24,0.22)]",
    expired: "bg-amber-50 text-amber-800 border-amber-200",
};
